import * as PushConstants  from './PushConstants';
import * as DateUtils      from 'lib/DateUtils';
import Button              from 'components/Button/Button.react';
import DashboardView       from 'dashboard/DashboardView.react';
import EmptyState          from 'components/EmptyState/EmptyState.react';
import LoaderContainer     from 'components/LoaderContainer/LoaderContainer.react';
import LoaderDots          from 'components/LoaderDots/LoaderDots.react';
import React               from 'react';
import history from 'dashboard/history';
import StatusIndicator     from 'components/StatusIndicator/StatusIndicator.react';
import styles              from './PushIndex.scss';
import stylesButton        from 'components/Button/Button.scss';
import stylesTable         from 'dashboard/TableView.scss';
import Toolbar             from 'components/Toolbar/Toolbar.react';
import Pagination          from 'rc-pagination';


import Tooltip                from 'rc-tooltip';

const PUSH_TYPE_ALL = 'all';
const PUSH_TYPE_CAMPAIGN = 'campaign';
const PUSH_TYPE_EXPERIMENT = 'experiment';
const PUSH_TYPE_API = 'API';
const PUSH_TYPE_TRANSLATION = 'translation';

const PUSH_STATUS_COLOR = {
  succeeded: 'green',
  failed: 'red',
  pending: 'blue',
  running: 'blue',
  scheduled: 'orange',
};

const PUSH_STATUS_CONTENT = {
  succeeded: 'SENT',
  failed: 'FAILED',
  pending: 'SENDING',
  scheduled: 'SCHEDULED',
  running: 'RUNNING',
};

const EXPERIMENT_GROUP = {
  A: 'GROUP B',
  B: 'GROUP A',
  launch: 'LAUNCH GROUP',
}

const DEFAULT_EMPTY_STATE_CONTENT = {
  description: 'You may need to configure push notifications for your app.',
  cta: 'Get started with Parse Push'
};

let getPushStatusType = (pushData) => {
  if(pushData[PushConstants.EXPERIMENT_FIELD]){
    return PUSH_TYPE_EXPERIMENT;
  } else if (pushData[PushConstants.TRANSLATION_ID_FIELD]){
    return PUSH_TYPE_TRANSLATION;
  } else if (pushData[PushConstants.SOURCE_FIELD] === 'webui'){
    return PUSH_TYPE_CAMPAIGN;
  } else if (pushData.source != 'rest') {
    return pushData.source
  } else {
    return PUSH_TYPE_API;
  }
}

let isChannelTargeted = (pushData) => {
  let query = pushData[PushConstants.QUERY_FIELD];
  let channelClause = false;
  if(!query) {
    return false;
  }

  let queryJSON = JSON.parse(query);
  let channels = queryJSON.channels;
  if (!channels) {
    return false;
  }

  let inClause = (channels.constructor === Object) && channels['$in'];
  let eqClause = channels.constructor === String;
  let additionalKeys = false;

  for (let key in queryJSON) {
    if (queryJSON.hasOwnProperty(key)) {
      if (key !== 'deviceType' && key !== 'channels') {
        additionalKeys = true;
      }
    }
  }

  return (inClause || eqClause) && !additionalKeys;
}

let getPushTarget = (pushData, availableDevices) => {
  if (isChannelTargeted(pushData)){
    return 'Channels';
  }
  if (availableDevices === undefined) {
    return (<LoaderDots />);
  }

  let query = pushData.query;
  if(typeof query == 'string'){ query = JSON.parse(query) }

  // if(query.deviceType && query.deviceType['$in'] && query.deviceType['$in'].length <= availableDevices.length) {
  if(typeof query === 'object' && Object.keys(query).length) {
    let query_str = JSON.stringify(query)

    // TODO for later to show correct audience name not just "Segment"
    // if (pushData.audience)
    // {
    //   return pushData.audience.name
    // }


    return <span>Segment</span>
  }
  return 'Everyone';
}


let whereHash = (pushData) => {
  let query = pushData[PushConstants.QUERY_FIELD];
  if(query) {
    return JSON.parse(query);
  }
  return null;
}

let getPushName = (pushData) => {
  let title = pushData[PushConstants.TITLE_FIELD];
  if(title){
    return (
      <strong>{title}</strong>
    );
  } else {
    let payload = pushData[PushConstants.PAYLOAD_FIELD];
    if(payload){
      let parsedPayload = payload; // JSON.parse(payload);
      return parsedPayload.alert ? parsedPayload.alert : payload;
    }
  }
}

let emptyStateContent = {
  'all': {
    title: 'No pushes to display yet.',
    description: DEFAULT_EMPTY_STATE_CONTENT.description,
    cta: DEFAULT_EMPTY_STATE_CONTENT.cta,
  },
  'campaign': {
    title: 'No push campaigns to display yet.',
    description: DEFAULT_EMPTY_STATE_CONTENT.description,
    cta: DEFAULT_EMPTY_STATE_CONTENT.cta,
  },
  'experiment': {
    title: 'No push experiments to display yet',
    description: DEFAULT_EMPTY_STATE_CONTENT.description,
    cta: DEFAULT_EMPTY_STATE_CONTENT.cta,
  },
  'api': {
    title: 'No API pushes to display yet',
    description: DEFAULT_EMPTY_STATE_CONTENT.description,
    cta: DEFAULT_EMPTY_STATE_CONTENT.cta,
  }
};

let getExperimentInfo = (experiment) => {
  if(!experiment){
    return '';
  }
  return (
    <div className={styles.experimentLabel}>{EXPERIMENT_GROUP[experiment.group]}</div>
  );
}

let getTranslationInfo = (translationLocale) => {
  if(!translationLocale){
    return '';
  }
  return (
    <div className={styles.translationLabel}>{translationLocale.toUpperCase()}</div>
  );
}

let formatStatus = (value, pushTime) => {

  if(value == 'pending' && DateUtils.isDateAfterNow(pushTime)) {
    value = 'scheduled';
  }

  if(value == 'running') {
    return (
      <LoaderDots />
    );
  }

  let color = PUSH_STATUS_COLOR[value];
  let status = PUSH_STATUS_CONTENT[value];

  return (
    <StatusIndicator color={color} status={status} />
  );
}

let getPushTime = (pushTime, updatedAt) => {
  let time = pushTime || updatedAt;

  let dateTime = new Date(time);
  let isLocal = time.indexOf('Z') === -1;
  let timeContent = DateUtils.yearMonthDayTimeFormatter(dateTime, !isLocal);
  let result  = [];
  if (isLocal) {
    result.push(
      <div key='localTime' className={styles.localTimeLabel}>LOCAL TIME</div>
    );
  };
  result.push(
     <div key='timeContent'>{timeContent}</div>
  );
  return result;
}

export default class PushIndex extends DashboardView {
  constructor() {
    super();
    this.section = 'Push';
    this.subsection = 'Activity'
    this.state = {
      pushes: [],
      pushCountMap: {},
      loading: true,
      currentPage: 1,
      availableDevices: undefined,
    }
  }

  handleFetch(category, page) {
    page = page || 0;

    let promise = this.context.currentApp.fetchPushNotifications(category, page);

    promise.then(({ push_status, push_data, pagination_info }) => {
      this.setState({
        pushes: push_status,
        paginationInfo: pagination_info,
        loading: false,
      });
    });
  }

  componentWillMount() {
    this.handleFetch(this.props.params.category);

    this.context.currentApp.fetchAvailableDevices().then(({ available_devices }) => {
      this.setState({
        availableDevices: available_devices
      });
    }, (error) => {
      this.setState({
        availableDevices: PushConstants.DEFAULT_DEVICES
      });
    });
  }

  componentWillUnmount() {}

  componentWillReceiveProps(nextProps) {}

  navigateToNew() {
    history.push(this.context.generatePath('push/new'));
  }

  navigateToDetails(objectId, e) {
    history.push(this.context.generatePath(`push/${objectId}`)); //TODO: Push Notification Details
    e.preventDefault();
    e.stopPropagation();
  }

  handleShowMore(page) {
    this.rows.scroll(0, 0);
    this.setState({ loading: true, currentPage: page});
    setTimeout(() => {
      this.handleFetch(this.props.params.category, page);
    }, 400);
  }

  tableData() {
    return this.state.pushes;
  }

  renderRow(push) {
    if(!push.data) {
      return
    }

    let messageData = getPushName(push.data)
    let isJSON = true;

    try {
      JSON.parse(messageData);
    } catch(e) {
      isJSON = false;
    }

    let pushObject = {
      from: getPushStatusType(push.data),
      to: getPushTarget(push.data, this.state.availableDevices),
      time: getPushTime(push.data.pushTime, push.updatedAt),
      message: JSON.parse(messageData)
    }

    return (
      <div className={styles.row} key={'row' + new Date() * Math.random()}>
        <div className={styles.colType}>
          <Tooltip key={`key-${push.data.objectId}`} placement="right" overlay={`objectId: ${push.data.objectId}`} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
            <span>{getPushStatusType(push.data)}</span>
          </Tooltip>
        </div>
        <div className={styles.colTarget}>
          {getTranslationInfo(push.data.translation_locale)}
          {getExperimentInfo(push.data.experiment)}
          {getPushTarget(push.data, this.state.availableDevices)}
        </div>
        <div className={styles.colPushesSent}>
          {
            DateUtils.isDateAfterNow(push.data.pushTime)
              ? '-'
              : push.data.numSent
          }
        </div>
        <div className={styles.colPushesSent}>
          {
            DateUtils.isDateAfterNow(push.data.pushTime)
              ? '-'
              : push.data.numFailed
          }
        </div>
        <div className={styles.colMessage}>
          { messageData }
        </div>
        <div className={styles.colTime}>{getPushTime(push.data.pushTime, push.updatedAt)}</div>
        <div className={styles.colStatus}>{formatStatus(push.data.status, push.data.pushTime)}</div>
        <div className={styles.colDetails}>
          <a
            className={[stylesButton.tableButton].join(' ')}
            href={this.context.generatePath(`push/${push.objectId}`)}
            onClick={this.navigateToDetails.bind(this, push.objectId)}>
            Details
          </a>
        </div>
      </div>
    );
  }

  renderToolbar() {
    return (
      <Toolbar
        section='Push'
        subsection={'Activity'}>
        <Button color='blue' value='Send a push' onClick={this.navigateToNew.bind(this)} />
      </Toolbar>
    );
  }

  renderHeaders() {
    return (
      <div className={[styles.row, styles.title].join(' ')}>
        <div className={styles.colType}>Sent from</div>
        <div className={styles.colTarget}>Target</div>
        <div className={styles.colPushesSent}>Pushes Sent</div>
        <div className={styles.colPushesFailed}>Pushes Failed</div>
        <div className={styles.colMessage}>Message</div>
        <div className={styles.colTime}>Time</div>
        <div className={styles.colStatus}>Status</div>
        <div className={styles.colDetails}>Details</div>
      </div>
    );
  }

  //NOTE: current solution is 'Show more' button. Can be changed to infinite scroll if req.
  renderExtras() {
    let paginationInfo = this.state.paginationInfo;

    if(!paginationInfo || paginationInfo.push_status_per_page > paginationInfo.push_status_display_count){
      return null;
    }

    return (
      <div className={[styles.footer].join(' ')}>
        {
          this.state.paginationInfo &&
            <Pagination
              total={this.state.paginationInfo.push_status_display_count - 30}
              current={this.state.currentPage}
              pageSize={30}
              showTitle={false}
              showQuickJumper={false}
              onChange={(current) => {
                this.handleShowMore(current)
              }} />
        }
      </div>
    );
  }

  renderEmpty() {
    let type = this.props.params.category || PUSH_TYPE_ALL;
    return (
      <EmptyState
        title={emptyStateContent[type].title}
        description={emptyStateContent[type].description}
        icon='push-solid'
      />
    );
  }


  //using custom renderContent as location of 'extras' are in different location
  renderContent() {
    let classes = [];
    let toolbar = this.renderToolbar();
    let data = this.tableData();
    let content = null;
    let showExtras = null;
    let headers = null;
    if (data !== undefined) {
      if (!Array.isArray(data)) {
        console.warn('tableData() needs to return an array of objects');
      } else {
        if (data.length === 0) {
          content = this.renderEmpty();
        } else {
          showExtras = true;
          classes.push(styles.settingsBoxBig);
          classes.push(styles.settingsBoxBigCustomMarginBottom);
          content = (
            <div className={stylesTable.rows}>
              {
                data.map((row) => this.renderRow(row))
              }
            </div>
          );
          headers = (
            <div>
              {this.renderHeaders()}
            </div>
          );
        }
      }
    }
    let extras = this.renderExtras ? this.renderExtras() : null;

    return (
      <div className={styles.settings_page}>
        {toolbar}
        <div className={[styles.holder, styles.hasFooter].join(' ')} ref={rows => this.rows = rows}>
          <div className={classes.join(' ')}>
            {headers}
            <LoaderContainer close={this.state.loading} inner={true}>
              {
                this.state.loading
                  ? <div className={stylesTable.rows}>
                      <div className={[styles.row, styles.loaderDots].join(' ')}>
                        <LoaderDots />
                      </div>
                    </div>
                  : content
              }
            </LoaderContainer>
          </div>
        </div>

        {
          showExtras ? extras : null
        }
      </div>
    );
  }
}
